import {filter, tap, ignoreElements} from 'rxjs/operators'
import {Epic} from 'redux-observable'
import {RootState, AppActions} from 'app/rootReducer'
import {policiesActions} from './policiesSlice'
import {usersEpics} from './Users/usersEpics'
import Toast from 'components/Basic/Toast'
import {toast} from 'react-toastify'
import {cloudAppEpics} from './CloudApp/cloudAppEpics'
import {policyErrorToast} from 'definitions/constant'
import {i18n} from 'i18n'
const {t} = i18n

const updatePolicyNameEpic: Epic<AppActions, AppActions, RootState> = action$ =>
  action$.pipe(
    filter(policiesActions.updatePolicyName.match),
    tap(({payload}) => localStorage.setItem('selectedPolicyName', payload)),
    ignoreElements(),
  )

const updatePolicyUpdateFieldEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.updatePolicyUpdateField.match),
    tap(({payload}) => {
      if (
        payload?.throwError &&
        (payload.throwError1 || payload.throwError2) &&
        (payload?.value1 || payload?.value2)
      ) {
        if (!toast.isActive(policyErrorToast)) {
          Toast({
            message: t('common:TAB_ENTER_ERROR'),
            type: 'error',
            customId: policyErrorToast,
          })
        }
      }
    }),
    ignoreElements(),
  )

export const policiesEpics = [
  ...usersEpics,
  ...cloudAppEpics,
  updatePolicyNameEpic,
  updatePolicyUpdateFieldEpic,
]
